import React from "react";

import { BannerBlock as BannerBlockValue } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonTextSecondary } from "../Clickables";
import { Svg } from "../Svg";
import { getThemeClass } from "../ThemedModule";

import styles from "./Banner.module.scss";

interface BannerProps {
    value: BannerBlockValue;
}

export const Banner = ({ value }: BannerProps) => {
    return (
        <section
            className={concatClassNames([
                styles.root,
                getThemeClass(value.module_theme),
            ])}
        >
            <div className={styles.inner}>
                {value.image && (
                    <div className={styles.image}>
                        <ImageChooserBlock value={value.image} attrs={{}} />
                    </div>
                )}
                <div className={styles.mainContent}>
                    <div
                        className={concatClassNames([
                            styles.content,
                            value.image ? styles.hasImage : null,
                        ])}
                    >
                        {value.headline && (
                            <p className={styles.headline}>{value.headline}</p>
                        )}
                        {value.body && (
                            <p className={styles.body}>{value.body}</p>
                        )}
                    </div>
                    {value.link && (
                        <ButtonTextSecondary
                            simpleLink={value.link}
                            className={styles.link}
                        >
                            {value.link.display_name}
                            <Svg name="arrow" />
                        </ButtonTextSecondary>
                    )}
                </div>
            </div>
        </section>
    );
};
